import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import { CGRF } from "tagTypes";

export const useGetAllCGRFGrievances = (query = {}) =>
  useGetQuery({
    endpoint: "grievance",
    query,
    tags: [CGRF],
  });

export const useGetAllCGRFGrievanceData = (id, query = {}) =>
  useGetQuery({
    endpoint: `grievance/${id}`,
    query,
    tags: [CGRF],
  });

export const useLazyGetCGRFGrievanceData = () => {
  const [cgrfGrievanceData, data] = useLazyGetQuery();
  const grievanceData = async (id, query = {}) =>
    await cgrfGrievanceData(
      {
        endpoint: `/grievance/${id}`,
        query,
        tags: [CGRF],
      },
      true
    ).unwrap();
  return [grievanceData, data];
};

export const useLazyGetAllGrievanceCategory = () => {
  const [cgrfGrievanceData, data] = useLazyGetQuery();
  const grievanceData = async (query = {}) =>
    await cgrfGrievanceData(
      {
        endpoint: "/grievance-catagory",
        query,
        tags: [],
      },
      true
    ).unwrap();
  return [grievanceData, data];
};

export const useLazyGetCGRFConsumerInfo = () => {
  const [cgrfConsumerInfo, data] = useLazyGetQuery();
  const consumerInfo = async (id, query = {}) =>
    await cgrfConsumerInfo(
      {
        endpoint: `/power/utility-consumer/${id}`,
        query,
        tags: [CGRF],
      },
      true
    ).unwrap();
  return [consumerInfo, data];
};

export const useUtilityConsumerContactInfoQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/user/utility-consumer",
    query,
    tags: [],
  });

export const usePostGrievanceForm = () => {
  const [createGrievanceForm, data] = usePostMutation();
  const createGrievance = async (payload, query = {}) =>
    await createGrievanceForm({
      endpoint: "/grievance",
      query,
      payload: payload || {},
      toastMessage: "Complaint registered successfully",
      tags: [CGRF],
    }).unwrap();

  return [createGrievance, data];
};

export const usePutGrievanceForm = () => {
  const [updateGrievanceForm, data] = usePutMutation();
  const updateForm = async (id, payload, query = {}) => {
    return await updateGrievanceForm({
      endpoint: `/grievance/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Application data updated successfully",
      tags: [CGRF],
    }).unwrap();
  };
  return [updateForm, data];
};

export const usePutCloseGrievance = () => {
  const [updateGrievanceForm, data] = usePutMutation();
  const updateForm = async (id, payload, query = {}) => {
    return await updateGrievanceForm({
      endpoint: `/grievance/${id}/close`,
      query,
      payload: payload || {},
      toastMessage: "Application closed successfully",
      tags: [CGRF],
    }).unwrap();
  };
  return [updateForm, data];
};
